import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterAutoexclusionUsers from 'views/customers/reports/autoexclusionUsers/filterAutoexclusionUsers'; // Importing filter component for autoexclusion users
import TableAutoexclusionUsers from 'views/customers/reports/autoexclusionUsers/tableAutoexclusionUsers'; // Importing table component for autoexclusion users
import DetailsAutoexclusionUsers from 'views/customers/reports/autoexclusionUsers/detailsAutoexclusionUsers'; // Importing details component for autoexclusion users
import RecordAutoexclusionUsers from 'views/customers/reports/autoexclusionUsers/recordAutoexclusionUsers'; // Importing record component for autoexclusion users
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the autoexclusion users view.
 * @extends JetView
 */
export default class autoexclusionUsersView extends JetView {
    /**
     * Configures the layout of the autoexclusion users view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for pagination
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from configuration
                },
            ],
        };

        // Right section configuration
        const right = {
            type: 'wide',
            rows: [DetailsAutoexclusionUsers], // Including details component
        };

        // Bottom left section configuration
        const bottom_left = {
            type: 'wide',
            rows: [TableAutoexclusionUsers, toolbar], // Including table and toolbar
        };

        // Left section configuration
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme, // Applying current theme
                    elements: [
                        {
                            view: 'label', // Label for the autoexclusion users title
                            label: _('Usuarios Autoexcluidos'), // Localized label text
                            width: 500,
                        },
                    ],
                },
                FilterAutoexclusionUsers, // Including filter component
            ],
        };

        // Returning the overall layout configuration
        return {
            type: 'wide',
            rows: [{ cols: [left] }, { cols: [bottom_left, right] }], // Combining left, bottom left, and right sections
        };
    }
}

// FILE DOCUMENTED
